module.exports = __webpack_public_path__ + "static/deep_dive_plan-6259c4f07b8da9345e426a582d6489c9.jpg";